import React from 'react';

import CasinoCRMApi from '../../../../casino/Api/CRM/CasinoCRMApi';
import CasinoTransaction from '../../../../casino/Api/Models/CasinoTransaction';
import Card from '../../../elements/common/Card';
import Row, { TableDetailsBody } from '../../../elements/common/TableDetailsRow';
import useAutoPaginator from '../../../hooks/useAutoPaginator';

import useNumberParams from '../../../hooks/useNumberParams';

import TransactionsTable from './TransactionsTable';

function BetsList() {
    const { id } = useNumberParams();
    const { items, isLoading, auto } = useAutoPaginator<CasinoTransaction>((page, params) => {
        return CasinoCRMApi.transactions.getPaginatedBySessionId(page, id, { params });
    });

    return (
        <>
            <Card title="Session Details">
                <TableDetailsBody>
                    <Row label="Session Id">{items[0]?.session_id}</Row>
                    <Row label="User email">{items[0]?.user.email}</Row>
                    <Row label="User phone">{items[0]?.user.phone}</Row>
                    <Row label="Casino Game provider">{items[0]?.casino_game?.creator_name}</Row>
                    <Row label="Casino Game name">{items[0]?.casino_game?.name}</Row>
                </TableDetailsBody>
            </Card>
            <TransactionsTable
                transactions={items}
                isLoading={isLoading}
                sortProps={auto.sort}
                autoSearch={auto.search}
                autoFilter={auto.filter}
                autoPaginator={auto.paginator}
            />
        </>
    );
}

export default BetsList;
